import { Button } from 'component/Button'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ContinueButton } from 'page/ProfileScreen/BasicSelfiesPanel/ContinueButton'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './FullbodyPhoto.module.scss'

type Props = {
  onContinue: () => void
}

// Загруженное по QR фото: подтверждаем его или просим загрузить другое.
export const FullbodyPhoto = observer(({ onContinue }: Props) => {
  const { common } = store.profile
  const { userPhoto } = common

  // Сбросили фото — шаг сам вернётся к экрану с QR-кодом.
  const onAnother = useLatestCallback(() => {
    common.discardUserPhoto()
  })

  const buttons = (
    <Space gap={24} columns wrap>
      <Button flat large action={onAnother}>
        <Space gap={16}>
          <Icon size={26} name="autorenew" />
          <Typo>
            {i18n('UploadAnotherPhoto')}
          </Typo>
        </Space>
      </Button>
      <ContinueButton action={onContinue} />
    </Space>
  )

  return (
    <Vertical gap={42} tall>
      <Typo size={32} medium upper center>
        {i18n('UploadFullbodyPhoto')}
      </Typo>
      {opt.sochi && buttons}
      <Space className={css.area} center>
        <Space className={css.frame}>
          <Img className={css.photo} src={userPhoto.src || userPhoto.url} cover />
        </Space>
      </Space>
      {!opt.sochi && buttons}
    </Vertical>
  )
})
